export const getters = {
  isAuthenticated: state => !!state.authToken,
  getAuthStatus: state => state.authStatus,
  getUserProfile: state => state.userProfile,
  getUserStatus: state => state.userStatus,
  getUsername: state => state.username,
  getUserId: state => state.userId,
  getConfirmEmailLoadingStatus: state => state.confirmEmailLoadingStatus,
  getForgotPasswordStatus: state => state.forgotPasswordStatus,
  getNewPasswordStatus: state => state.newPasswordStatus,
  getRoles: state => state.userRoles,
  getIsCPA: state => state.isCPA,
  // Get CPA id for route.
  getCPAId: state => state.CPAId,
};
